import type { AssociationType } from '@fs/zion-tree-types'
import { type FilterChoiceCategory, type FilterChoiceType } from '../changelog/types'

export const associationTypeKeyMap: Record<AssociationType, string> = {
  ANCESTOR_TO_DESCENDANT: 'tree-person.relationship-type.ANCESTOR_TO_DESCENDANT',
  MASTER_TO_APPRENTICE: 'tree-person.relationship-type.MASTER_TO_APPRENTICE',
  EMPLOYER_TO_EMPLOYEE: 'tree-person.relationship-type.EMPLOYER_TO_EMPLOYEE',
  SLAVEHOLDER_TO_ENSLAVED_PERSON: 'tree-person.relationship-type.SLAVEHOLDER_TO_ENSLAVED_PERSON',
  GODPARENT_TO_GODCHILD: 'tree-person.relationship-type.GODPARENT_TO_GODCHILD',
  HEAD_OF_HOUSEHOLD_TO_OCCUPANT: 'tree-person.relationship-type.HEAD_OF_HOUSEHOLD_TO_OCCUPANT',
  NEIGHBOR_TO_NEIGHBOR: 'tree-person.relationship-type.NEIGHBOR_TO_NEIGHBOR',
  RELATIVE_TO_RELATIVE: 'tree-person.relationship-type.RELATIVE_TO_RELATIVE',
}

export const relationshipTypeKeyMap: Record<AssociationType | 'COUPLE' | 'PARENT_CHILD', string> = {
  ...associationTypeKeyMap,
  COUPLE: 'tree-person.relationship-type.COUPLE',
  PARENT_CHILD: 'tree-person.relationship-type.PARENT_CHILD',
}

export const changelogFilterByKeyMap: Record<`${'filter-by'}_${FilterChoiceType}`, string> = {
  'filter-by_ALL': 'change-log.ALL.filter-by',
  'filter-by_ADOPTIVE_PARENT': 'change-log.ADOPTIVE_PARENT.filter-by',
  'filter-by_AFFILIATION': 'change-log.AFFILIATION.filter-by',
  'filter-by_ALTERNATE_NAME': 'change-log.ALTERNATE_NAME.filter-by',
  'filter-by_ANNULMENT': 'change-log.ANNULMENT.filter-by',
  'filter-by_APPRENTICESHIP': 'change-log.APPRENTICESHIP.filter-by',
  'filter-by_AUDIO': 'change-log.AUDIO.filter-by',
  'filter-by_BAR_MITZVAH': 'change-log.BAR_MITZVAH.filter-by',
  'filter-by_BAS_MITZVAH': 'change-log.BAS_MITZVAH.filter-by',
  'filter-by_BIOLOGICAL_PARENT': 'change-log.BIOLOGICAL_PARENT.filter-by',
  'filter-by_BIRTH': 'change-log.BIRTH.filter-by',
  'filter-by_BURIAL': 'change-log.BURIAL.filter-by',
  'filter-by_CASTE': 'change-log.CASTE.filter-by',
  'filter-by_CHRISTENING': 'change-log.CHRISTENING.filter-by',
  'filter-by_CLAN_NAME': 'change-log.CLAN_NAME.filter-by',
  'filter-by_COMMON_LAW_MARRIAGE': 'change-log.COMMON_LAW_MARRIAGE.filter-by',
  'filter-by_COUPLE_NEVER_HAD_CHILDREN': 'change-log.COUPLE_NEVER_HAD_CHILDREN.filter-by',
  'filter-by_CREMATION': 'change-log.CREMATION.filter-by',
  'filter-by_DEATH': 'change-log.DEATH.filter-by',
  'filter-by_DISCUSSIONS': 'change-log.DISCUSSIONS.filter-by',
  'filter-by_NOTES': 'tree-person.notes.header',
  'filter-by_DIVORCE': 'change-log.DIVORCE.filter-by',
  'filter-by_DOCUMENT': 'change-log.DOCUMENT.filter-by',
  'filter-by_EMANCIPATION': 'change-log.EMANCIPATION.filter-by',
  'filter-by_EMPLOYMENT': 'change-log.EMPLOYMENT.filter-by',
  'filter-by_ENSLAVEMENT': 'change-log.ENSLAVEMENT.filter-by',
  'filter-by_ETHNICITY': 'change-log.ETHNICITY.filter-by',
  'filter-by_FIRST_ANCESTOR': 'change-log.first-ancestor.filter-by',
  'filter-by_FOSTER_PARENT': 'change-log.FOSTER_PARENT.filter-by',
  'filter-by_GODPARENTHOOD': 'change-log.GODPARENTHOOD.filter-by',
  'filter-by_GUARDIAN_PARENT': 'change-log.GUARDIAN_PARENT.filter-by',
  'filter-by_HOUSEHOLD': 'change-log.HOUSEHOLD.filter-by',
  'filter-by_IMMIGRATION': 'change-log.IMMIGRATION.filter-by',
  'filter-by_LIFE_SKETCH': 'change-log.LIFE_SKETCH.filter-by',
  'filter-by_LIVED_TOGETHER': 'change-log.LIVED_TOGETHER.filter-by',
  'filter-by_MARRIAGE': 'change-log.MARRIAGE.filter-by',
  'filter-by_MERGES': 'change-log.MERGES.filter-by',
  'filter-by_SPLITS': 'tree-person.split.filter-by',
  'filter-by_MILITARY_SERVICE': 'change-log.MILITARY_SERVICE.filter-by',
  'filter-by_NATIONAL_ID': 'change-log.NATIONAL_ID.filter-by',
  'filter-by_NATIONALITY': 'change-log.NATIONALITY.filter-by',
  'filter-by_NATURALIZATION': 'change-log.NATURALIZATION.filter-by',
  'filter-by_NEIGHBORHOOD': 'change-log.NEIGHBOR_TO_NEIGHBOR.filter-by',
  'filter-by_NO_CHILDREN': 'change-log.NO_CHILDREN.filter-by',
  'filter-by_NO_COUPLE_RELATIONSHIPS': 'change-log.NO_COUPLE_RELATIONSHIPS.filter-by',
  'filter-by_NOBILITY_TITLE': 'change-log.NOBILITY_TITLE.filter-by',
  'filter-by_OBITUARY': 'change-log.OBITUARY.filter-by',
  'filter-by_OCCUPATION': 'change-log.OCCUPATION.filter-by',
  'filter-by_OTHER_EVENT': 'change-log.OTHER_EVENT.filter-by',
  'filter-by_OTHER_FACT': 'change-log.OTHER_FACT.filter-by',
  'filter-by_PERSON_NOT_A_MATCH': 'change-log.PERSON_NOT_A_MATCH.filter-by',
  'filter-by_PHOTO': 'change-log.PHOTO.filter-by',
  'filter-by_PHYSICAL_DESCRIPTION': 'change-log.PHYSICAL_DESCRIPTION.filter-by',
  'filter-by_PREFERRED_NAME': 'change-log.PREFERRED_NAME.filter-by',
  'filter-by_RELATION': 'change-log.RELATIVE_TO_RELATIVE.filter-by',
  'filter-by_RELIGION': 'change-log.RELIGION.filter-by',
  'filter-by_RESIDENCE': 'change-log.RESIDENCE.filter-by',
  'filter-by_SEX': 'change-log.SEX.filter-by',
  'filter-by_SOURCES': 'change-log.SOURCES.filter-by',
  'filter-by_STEP_PARENT': 'change-log.STEP_PARENT.filter-by',
  'filter-by_STILLBORN': 'change-log.STILLBORN.filter-by',
  'filter-by_STORY': 'change-log.STORY.filter-by',
  'filter-by_TRIBE_NAME': 'change-log.TRIBE_NAME.filter-by',
}

const changelogLabelKeyMap: Record<
  `label_${'couple-relationship' | 'parent-child-relationship' | 'association'}`,
  string
> = {
  'label_couple-relationship': 'change-log.couple-relationship.label',
  'label_parent-child-relationship': 'change-log.parent-child-relationship.label',
  label_association: 'change-log.association.label',
}

export const changelogSubheaderKeyMap = { ...changelogFilterByKeyMap, ...changelogLabelKeyMap }

export const changelogSubheaderAssociationKeyMap: Record<
  Extract<'FilterChoiceType', 'EMANCIPATION' | 'ENSLAVEMENT' | keyof typeof associationTypeKeyMap>,
  string
> = {
  ...associationTypeKeyMap,
  EMANCIPATION: 'tree-person.relationship-type.EMANCIPATION',
  ENSLAVEMENT: 'tree-person.relationship-type.ENSLAVEMENT',
}

export const changeLogFilterGroupHeadingKeyMap: Record<FilterChoiceCategory, string> = {
  ALL: 'change-log.ALL.filter-by',
  VITALS: 'change-log.vitals.filter-by',
  ALTERNATE_NAME: 'change-log.ALTERNATE_NAME.filter-by',
  EVENTS: 'change-log.events.filter-by',
  FACTS: 'change-log.facts.filter-by',
  SOURCES: 'change-log.SOURCES.filter-by',
  MEMORIES: 'change-log.memories.filter-by',
  MERGES: 'change-log.MERGES.filter-by',
  SPLITS: 'tree-person.split.filter-by',
  DISCUSSIONS: 'change-log.DISCUSSIONS.filter-by',
  PERSON_NOT_A_MATCH: 'change-log.PERSON_NOT_A_MATCH.filter-by',
  COUPLE_RELATIONSHIPS: 'change-log.couple-relationships.filter-by',
  PARENT_CHILD_RELATIONSHIPS: 'change-log.parent-child-relationships.filter-by',
  ASSOCIATION: 'change-log.association.filter-by',
  FIRST_ANCESTOR: 'change-log.FIRST_ANCESTOR.filter-by',
}
